var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPenguin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 427,
    height: 658,
    viewBox: "0 0 427 658",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.87 577.93C108.54 584.23 43.9401 633.75 69.6201 644.55C95.3001 655.35 169.82 659.85 183.91 647.25C191.15 640.78 204.09 624.56 205.62 609.35C207.15 624.56 220.06 640.78 227.29 647.25C241.37 659.85 315.93 655.34 341.61 644.55C367.29 633.75 302.69 584.23 246.36 577.93C217.36 580.97 206.92 591.56 205.62 603.7C204.31 591.55 193.88 580.96 164.88 577.93H164.87Z",
    fill: "url(#paint0_radial_5_3)",
    stroke: "black",
    strokeWidth: 6.18
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.88 577.95C137.23 581.04 107.62 594.55 87.6401 608.77C117.9 623.98 154.9 633.35 195.01 634.42C200.15 627.07 204.75 618.07 205.63 609.36C206.5 617.98 210.99 626.91 216.06 634.22C255.51 632.41 291.74 622.58 321.23 607.1C301.32 593.49 272.94 580.92 246.37 577.95C217.37 580.99 206.93 591.58 205.63 603.72C204.32 591.57 193.89 580.98 164.89 577.95H164.88Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M396.73 400.93C396.73 428.51 391.67 456.07 381.95 481.55C372.23 507.02 357.86 530.39 339.9 549.89C321.95 569.39 300.44 585 276.99 595.55C253.54 606.1 228.17 611.58 202.79 611.58C177.41 611.58 152.04 606.1 128.59 595.55C105.14 585 83.6302 569.39 65.6802 549.89C47.7302 530.39 33.3499 507.03 23.6299 481.55C13.9099 456.08 8.8601 428.51 8.8501 400.93C8.8501 373.34 13.8801 345.76 23.5901 320.27C33.3001 294.78 47.6799 281.15 65.6299 261.64C83.5799 242.13 105.1 226.51 128.56 215.95C152.02 205.39 177.4 199.9 202.79 199.9C228.18 199.9 253.57 205.39 277.02 215.95C300.48 226.51 321.99 242.13 339.95 261.64C357.91 281.15 372.28 294.78 381.99 320.27C391.7 345.76 396.74 373.34 396.73 400.93Z",
    fill: "url(#paint1_radial_5_3)",
    stroke: "black",
    strokeWidth: 6.18,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M162.97 260.71C136.1 260.71 114.28 287.99 114.28 321.6C114.28 355.21 136.1 382.49 162.97 382.49C178.76 382.49 192.77 373.06 201.66 358.47C210.55 373.07 224.59 382.49 240.39 382.49C267.26 382.49 289.08 355.21 289.08 321.6C289.08 287.99 267.26 260.71 240.39 260.71C224.6 260.71 210.55 270.13 201.66 284.73C192.77 270.14 178.75 260.71 162.97 260.71Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 6.18,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M298.65 506.29C298.31 562.7 255.94 608.14 204.01 607.77C152.56 607.4 110.94 562.18 110.61 506.29C110.27 449.88 152.09 403.85 204.01 403.48C255.94 403.11 298.31 448.54 298.65 504.96C298.65 505.41 298.65 505.85 298.65 506.3V506.29Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 6.18,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M389.09 342.34C389.48 347.82 389.71 353.34 389.71 358.93C389.71 475.25 302.79 569.64 195.73 569.64C107.38 569.64 32.8199 505.35 9.43994 417.51C17.2399 526.07 100.84 611.63 202.76 611.63C309.82 611.63 396.74 517.23 396.74 400.92C396.74 380.59 394.04 360.94 389.09 342.34Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M203.99 365.74C187.03 365.74 168.59 382.52 169.33 393.12C170.07 403.72 199.56 447.88 206.2 447.88C212.84 447.88 238.65 404.6 237.91 392.23C237.17 379.86 215.05 364.85 203.99 365.73V365.74Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M193.15 332.34C193.21 339.64 187.81 345.61 181.09 345.68C174.37 345.75 168.87 339.88 168.81 332.58C168.81 332.5 168.81 332.42 168.81 332.34C168.75 325.04 174.15 319.07 180.87 319C187.59 318.93 193.09 324.8 193.15 332.1C193.15 332.18 193.15 332.26 193.15 332.34Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 6.18,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M236.71 332.34C236.77 339.64 231.37 345.61 224.65 345.68C217.93 345.75 212.43 339.88 212.37 332.58C212.37 332.5 212.37 332.42 212.37 332.34C212.31 325.04 217.71 319.07 224.43 319C231.15 318.93 236.65 324.8 236.71 332.1C236.71 332.18 236.71 332.26 236.71 332.34Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 6.18,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M354.42 373.77C297.39 398.83 379.53 487.01 321.96 572.87C311.32 588.74 392.47 570.56 415.71 485.09C438.31 401.97 408.07 354.28 354.42 373.77V373.77Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 6.09,
    strokeMiterlimit: 4.87
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M354.42 373.77C297.39 398.83 414.74 494.33 321.96 572.87C295.85 594.97 392.47 570.56 415.71 485.09C438.31 401.97 408.07 354.28 354.42 373.77V373.77Z",
    fill: "url(#paint2_radial_5_3)",
    stroke: "black",
    strokeWidth: 6.09,
    strokeMiterlimit: 4.87
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M203.31 355.71C186.35 355.71 167.91 371.32 168.65 381.18C169.39 391.04 198.88 432.11 205.52 432.11C212.16 432.11 237.97 391.85 237.23 380.35C236.49 368.85 214.37 354.88 203.31 355.7V355.71Z",
    fill: "url(#paint3_linear_5_3)",
    stroke: "black",
    strokeWidth: 6.18
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6299 365C87.7599 337.98 101.32 457.72 203.97 469.83C222.94 472.07 156.36 521.89 76.3198 483.95C-1.52015 447.06 -18.0701 393.07 31.6299 365V365Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 6.09,
    strokeMiterlimit: 4.87
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6299 365C87.7599 337.98 83.9702 489.23 203.97 469.83C237.74 464.37 156.36 521.89 76.3198 483.95C-1.52015 447.06 -18.0701 393.07 31.6299 365V365Z",
    fill: "url(#paint4_radial_5_3)",
    stroke: "black",
    strokeWidth: 6.09,
    strokeMiterlimit: 4.87
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M313.19 239.22C269.77 159.29 192.81 152.25 154.68 166.36C162.97 118.16 186.18 60.68 185.36 9.12997C272.85 -10.32 333.86 25.73 377.1 94.78C334.59 156.65 314.75 209.11 302.96 286.52C235.24 222.68 193.93 175.38 134.21 163.9C67.95 151.16 -3.18995 203.82 83.2501 243.52C112.9 219.52 136.51 215.27 180.25 243.07C245.06 284.7 310.01 326.74 351.54 301.87C385.46 287.99 373.74 244.57 313.19 239.23V239.22Z",
    fill: "#5B5B5B",
    stroke: "#2D2D2D",
    strokeWidth: 7.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M189.43 160.57C176.17 160.65 164.22 162.85 154.68 166.37L161.82 172.15C207.92 191.05 246.15 232.96 302.96 286.52C305.61 269.1 308.67 252.95 312.3 237.67C279.7 178.96 228.84 160.35 189.43 160.57V160.57ZM312.3 237.67C312.59 238.19 312.89 238.69 313.18 239.22C312.96 238.42 312.73 237.64 312.51 236.84C312.44 237.12 312.37 237.39 312.3 237.67V237.67Z",
    fill: "url(#paint5_radial_5_3)",
    stroke: "#2D2D2D",
    strokeWidth: 7.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5_3",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(198.153 551.263) rotate(90) scale(100.076 201.386)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE632"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5232"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_5_3",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(160.414 89.6672) rotate(-90) scale(315.013 259.718)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_5_3",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(119.863 218.015) rotate(-54.1) scale(164.743 376.301)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5_3",
    x1: 174.935,
    y1: 403.102,
    x2: 214.726,
    y2: 403.102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE632"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5232"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_5_3",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-272.371 357.988) rotate(89.63) scale(164.743 401.191)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_5_3",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(216.701 231.586) scale(75.4572 60.5316)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE632"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5232"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenguin);
export default __webpack_public_path__ + "static/media/Penguin.1d7978b9ed3982a5307e2da6ec714481.svg";
export { ForwardRef as ReactComponent };